/** @format */
import { TransactionSummary } from '../../config/types';

export const transformExpiredQuotes = (
    transaction: TransactionSummary
): TransactionSummary => {
    const tx = JSON.parse(JSON.stringify(transaction));

    if (tx.quote) {
        tx.quote.expired = true;
    }

    return tx;
};
